<template>
    <div class="customer-dashboard">
        <div class="IFrameLoader" id="my-superset-container">
            <h1>Dashboard is being loaded ...</h1>
        </div>
    </div>
</template>

<script>
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { APACHE_SUPERSET } from '@/assets/js/config';

export default {
    mixins: [helperFunctionMixin],
    methods: {
        getDashboardId() {
            let dashboardId = "d89a33ba-bdd3-4445-b7b5-d6745a229a59";
            switch (_gAuth.appCode()) {
                case 'vps-v2':
                    dashboardId = "c0d81e8e-05db-44b9-9396-b2e006b0f640";
                    break;

                default:
                    dashboardId = "d89a33ba-bdd3-4445-b7b5-d6745a229a59";
                    break;
            }
            return dashboardId;
        },
        async guestToken(){
            const dashboard_id = this.getDashboardId();
            const apache_superset_token = localStorage.getItem(`superset_token_${dashboard_id}`) || '';
            const result = await axios.get(services.access_control+'get_dashboard_token', {
                headers: getHeader(),
                params: {
                    dashboard_id,
                    apache_superset_token
                }
            });
            const token = result.data.token;
            if (token) {
                localStorage.setItem(`superset_token_${dashboard_id}`, token);
                return token;
            }
            return token;
        }
    },
    created() {
        setTimeout(() => {

            embedDashboard({
                id: this.getDashboardId(), // given by the Superset embedding UI
                supersetDomain: APACHE_SUPERSET,
                mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
                fetchGuestToken: () => this.guestToken(),
                dashboardUiConfig: {
                    hideTitle: true,
                    filters: {
                        expanded: false,
                        visible: false
                    },
                },
            });
        }, 2000);

        console.log('KPIReport')
    }
}
</script>